<template>
  <div class="entity__activity__user">
    <div class="entity__activity__user__description">
      <div class="label-info">
        {{ $t('entities.activities.period_interval') }}:&nbsp;
        <template v-if="entityActivityUser.start_date && entityActivityUser.end_date">
          <span>
            {{ entityActivityUser.start_date | localTime('YYYY-MM-DD HH:mm') }}
          </span>
          <span> {{ $t('entities.activities.revision.to')}}</span>
          <span>
            {{ entityActivityUser.end_date | localTime('YYYY-MM-DD HH:mm') }}
          </span>
        </template>
        <template v-else-if="entityActivityUser.start_date">
          <span>{{$t('entities.activities.revision.from')}} </span>
          <span>{{ entityActivityUser.start_date | localTime('YYYY-MM-DD HH:mm') }}</span>
        </template>
        <template v-else-if="entityActivityUser.end_date">
          <span>{{ $t('entities.activities.revision.until')}} </span>
          <span>{{ entityActivityUser.end_date | localTime('YYYY-MM-DD HH:mm') }}</span>
        </template>
        <template v-else>
          <span>{{ $t('entities.activities.revision.undefined_period') }}</span>
        </template>
      </div>
      <div class="label-info">
        {{ $t('entities.activities.revision.entity')}}:&nbsp;
        <span>{{ entityActivityUser.entity.name }}</span>
      </div>
      <div class="label-info">
        {{ $t('entities.activities.revision.activity')}}:&nbsp;
        <span>{{ $t(`evocall.activities.${entityActivityUser.activity.id}`, entityActivityUser.activity.name) }}</span>
      </div>
      <div class="label-info">
        {{ $t('entities.activities.revision.user')}}:&nbsp;
        <span v-if="entityActivityUser.user">{{ entityActivityUser.user.name }}</span>
        <span v-else>{{ $t('entities.activities.revision.no_user_selected') }}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    entityActivityUser: {
      type: Object,
      required: true
    }
  }
}
</script>
<style lang="scss" scoped>
.entity__activity__user {
  display: flex;
  justify-content: flex-start;

  &:hover {
    cursor: pointer;
  }

  &__description {
    margin-bottom: 0rem;
    & .label-info {
      margin-bottom: 0.2rem;
    }
  }
}
</style>
